export default "__VITE_ASSET__B5Mpdt5V__"